'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stateController = require('./state-controller');

var _stateController2 = _interopRequireDefault(_stateController);

var _stateStore = require('./state-store');

var _stateStore2 = _interopRequireDefault(_stateStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Optional component wrappers and utilities for state management;
 * exported in the main {@link panel} module for convenience.
 * @module component-utils
 * @example
 * // direct top-level import
 * import {ProxyComponent, StateController} from 'panel';
 * // module import
 * import {ComponentUtils} from 'panel';
 * const {ProxyComponent, StateController} = ComponentUtils;
 */

exports.default = {
  /** {@link StateController} class, to be subclassed by apps */
  StateController: _stateController2.default,

  /** A simple subscribable state store */
  StateStore: _stateStore2.default
};